import { useQuery } from '@tanstack/react-query';
import { fetchArticles, fetchArticle } from './request';
import { articleKeys } from './key';

export const useArticles = (search?: string) => {
  return useQuery({
    queryKey: articleKeys.list(search),
    queryFn: () => fetchArticles(search),
  });
};

export const useArticle = (id: number | string | undefined) => {
  return useQuery({
    queryKey: articleKeys.detail(id ?? 0),
    queryFn: () => fetchArticle(id as number | string),
    enabled: id != null && id !== '',
  });
};
